<template>
  <div class="view-box columns bg-light">
    <div v-if="showHeader" class="ai-header-wrapper">
      <ai-header
        button-route="new"
        :icon="icon"
        :header-title="formatedHeaderTitle"
        :show-back-button="showBackButton"
        :back-url="backUrl"
      />

      <RAGStorage v-if="isKnowledgeBaseRoute" />
    </div>

    <keep-alive v-if="keepAlive">
      <router-view></router-view>
    </keep-alive>
    <router-view v-else></router-view>
  </div>
</template>

<script>
import AiHeader from './AiHeader.vue';
import RAGStorage from './knowledge_base/RAGStorage.vue';

export default {
  components: {
    'ai-header': AiHeader,
    RAGStorage,
  },
  props: {
    headerTitle: { type: String, default: '' },
    icon: { type: String, default: '' },
    keepAlive: {
      type: Boolean,
      default: true,
    },

    showBackButton: {
      type: Boolean,
      default: false,
    },
    backUrl: {
      type: [String, Object],
      default: '',
    },
    showHeader: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    formatedHeaderTitle() {
      let title = this.$t(this.headerTitle);
      return title;
    },
    isKnowledgeBaseRoute() {
      return this.$route.name === 'ai_knowledge_base';
    },
  },
};
</script>
<style scoped>
.view-box.columns {
  flex: 1 1 auto;
  max-width: 100%;
  width: 100%;
  overflow-x: hidden;
  box-sizing: border-box;
  min-width: 0;
}

.ai-header-wrapper {
  background: #fff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  max-width: 100%;
  width: 100%;
  box-sizing: border-box;
  padding-right: 1rem;
}
</style>
